// extracted by mini-css-extract-plugin
export default {"share_comment":"index_share_comment_j-6-x clearfix"};